import { isValidCampaignSlug, useCampaignSlug } from '@/components/Functional/hooks-core/useCampaignSlug'
import type { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

// v1 のログイン画面 `/{campaign}/auth/signin` は v2 では廃止され、
// ログインは Auth v2 サーバの LINE 認証フローに統合されている。
// 旧 URL へアクセスされた場合は home（`/{campaign}`）へリダイレクトする。
const AuthSigninRedirectPage: NextPage = () => {
  const router = useRouter()
  const { campaignSlug, gen } = useCampaignSlug()

  useEffect(() => {
    // SSG ハイドレーション前はスラグが確定しないため遷移しない
    // （未確定だと `/[campaign]/` のプレースホルダへ誤遷移するリスクがある）
    if (!router.isReady) return
    if (!isValidCampaignSlug(campaignSlug)) return
    router.replace(gen('/'))
  }, [router, campaignSlug, gen])

  return null
}

export default AuthSigninRedirectPage

export { getStaticPaths, getStaticProps } from '@/components/Functional/utils/getStaticFunctions'
